import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import JobCalendarData from './JobCalendarData';
import moment from 'moment';

class JobCalendar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobs: this.props.jobs,
            overview: 'daily',
            selected_date: '',
        };
    }

    handleDateChange = (date) => {
        let selected_date = new Date(date).setHours(0, 0, 0, 0);

        this.setState({
            selected_date: selected_date,
        });
    };

    isWeekday = (date) => {
        const day = new Date(date).getDay();
        return day !== 0 && day !== 6;
    };

    handleClick = (overview) => {
        this.setState({
            overview: overview,
        });
    };

    getWeeklyOverview = (selected_date, jobs) => {
        let startOfWeek = moment(selected_date).startOf('week').format('YYYY-MM-DD');
        let endOfWeek = moment(selected_date).endOf('week').format('YYYY-MM-DD');

        return jobs.filter((job) => {
            return moment(job.execution_date).isBetween(startOfWeek, endOfWeek);
        });
    };

    render() {
        let jobs;
        if (this.state.overview === 'daily') {
            jobs = this.props.jobs.filter((job) => {
                return new Date(job.execution_date).setHours(0, 0, 0, 0) === this.state.selected_date;
            });
        } else {
            jobs = this.getWeeklyOverview(this.state.selected_date, this.props.jobs);
        }
        let overview = this.state.overview;
        return (
            <div>
                <DatePicker
                    inline
                    selected={this.state.selected_date || ''}
                    onChange={(date) => this.handleDateChange(date)}
                    filterDate={(date) => this.isWeekday(date)}
                    showWeekNumbers
                >
                    <div className="mb-2">
                        <button
                            type="button"
                            className={
                                overview === 'daily' ? 'btn btn-cw-primary mr-1' : 'btn btn-outline-cw-primary mr-1'
                            }
                            onClick={() => this.handleClick('daily')}
                        >
                            Daily view
                        </button>
                        <button
                            type="button"
                            className={overview === 'weekly' ? 'btn btn-cw-primary' : 'btn btn-outline-cw-primary'}
                            onClick={() => this.handleClick('weekly')}
                        >
                            Weekly view
                        </button>
                    </div>
                </DatePicker>
                <div className="row mt-2">
                    {jobs.map((job) => {
                        return <JobCalendarData key={job.id} job={job} />;
                    })}
                </div>
            </div>
        );
    }
}

if (document.getElementById('jobCalendar')) {
    let element = document.getElementById('jobCalendar');
    ReactDOM.render(<JobCalendar jobs={JSON.parse(element.dataset.jobs)} />, element);
}

export default JobCalendar;
